export enum CurrencyFormat {
  NUMBER_FORMAT_DOT = 'dot',
  NUMBER_FORMAT_COMMA = 'comma',
}

export const CurrencyFormatSymbol = {
  [CurrencyFormat.NUMBER_FORMAT_DOT]: '.',
  [CurrencyFormat.NUMBER_FORMAT_COMMA]: ',',
};
